export enum CHECKOUT_FORM_FIELDS {
	ID = 'id',
	BACKGROUND_IMAGE = 'checkoutPageBackgroundImage',
	PRIMARY_COLOR = 'checkoutPagePrimaryColor',
	SECONDARY_COLOR = 'checkoutPageSecondaryColor',
	FONT_COLOR = 'checkoutPageFontColor',
	LOGO = 'logoFile',
	FAVICON = 'favicon',
	IS_ONE_COLUMN = 'isCheckoutOneColumn',
}

export enum CHECKOUT_FORM_FIELDS_NAMES {
	BACKGROUND_IMAGE = 'CHECKOUT_CONFIGURATIONS.BGC_IMAGE',
	PRIMARY_COLOR = 'CHECKOUT_CONFIGURATIONS.PRIMARY_COLOR',
	SECONDARY_COLOR = 'CHECKOUT_CONFIGURATIONS.SECONDARY_COLOR',
	FONT_COLOR = 'CHECKOUT_CONFIGURATIONS.FONT_COLOR',
	LOGO = 'CHECKOUT_CONFIGURATIONS.LOGO',
	FAVICON = 'CHECKOUT_CONFIGURATIONS.FAVICON',
	IS_ONE_COLUMN = 'CHECKOUT_CONFIGURATIONS.IS_ONE_COLUMN',
}

export type CheckoutFieldsTypes = {
	[CHECKOUT_FORM_FIELDS.ID]: string,
	[CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE]: string,
	[CHECKOUT_FORM_FIELDS.PRIMARY_COLOR]: string,
	[CHECKOUT_FORM_FIELDS.SECONDARY_COLOR]: string,
	[CHECKOUT_FORM_FIELDS.FONT_COLOR]: string,
	[CHECKOUT_FORM_FIELDS.LOGO]: string,
	[CHECKOUT_FORM_FIELDS.FAVICON]: string,
	[CHECKOUT_FORM_FIELDS.IS_ONE_COLUMN]: boolean,
};

export type CheckoutFieldsReturnTypes = {
	id: string | null,
	checkoutPageBackgroundImage: string | null,
	checkoutPagePrimaryColor: string | null,
	checkoutPageSecondaryColor: string | null,
	checkoutPageFontColor: string | null,
	logoFile: string | null,
	favicon: string | null,
	isCheckoutOneColumn: boolean,
};

export const initialCheckoutValues: CheckoutFieldsTypes = {
	[CHECKOUT_FORM_FIELDS.ID]: '',
	[CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE]: '',
	[CHECKOUT_FORM_FIELDS.PRIMARY_COLOR]: '',
	[CHECKOUT_FORM_FIELDS.SECONDARY_COLOR]: '',
	[CHECKOUT_FORM_FIELDS.FONT_COLOR]: '',
	[CHECKOUT_FORM_FIELDS.LOGO]: '',
	[CHECKOUT_FORM_FIELDS.FAVICON]: '',
	[CHECKOUT_FORM_FIELDS.IS_ONE_COLUMN]: false,
};

export const getFormattedCheckoutFormFields = (formikValues): CheckoutFieldsReturnTypes => ({
	id: formikValues?.[CHECKOUT_FORM_FIELDS.ID],
	checkoutPageBackgroundImage: formikValues?.[CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE],
	checkoutPagePrimaryColor: formikValues?.[CHECKOUT_FORM_FIELDS.PRIMARY_COLOR],
	checkoutPageSecondaryColor: formikValues?.[CHECKOUT_FORM_FIELDS.SECONDARY_COLOR],
	checkoutPageFontColor: formikValues?.[CHECKOUT_FORM_FIELDS.FONT_COLOR],
	logoFile: formikValues?.[CHECKOUT_FORM_FIELDS.LOGO],
	favicon: formikValues?.[CHECKOUT_FORM_FIELDS.FAVICON],
	isCheckoutOneColumn: formikValues?.[CHECKOUT_FORM_FIELDS.IS_ONE_COLUMN],
});

export const convertToCheckoutInitial = (data): CheckoutFieldsReturnTypes => ({
	[CHECKOUT_FORM_FIELDS.ID]: data?.id ? data?.id : '',
	[CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE]: data?.checkoutPageBackgroundImage,
	[CHECKOUT_FORM_FIELDS.PRIMARY_COLOR]: data?.checkoutPagePrimaryColor ? data?.checkoutPagePrimaryColor : '#ffffff',
	[CHECKOUT_FORM_FIELDS.SECONDARY_COLOR]: data?.checkoutPageSecondaryColor ? data?.checkoutPageSecondaryColor : '#ffffff',
	[CHECKOUT_FORM_FIELDS.FONT_COLOR]: data?.checkoutPageFontColor ? data?.checkoutPageFontColor : '#000000',
	[CHECKOUT_FORM_FIELDS.LOGO]: data?.logoFile,
	[CHECKOUT_FORM_FIELDS.FAVICON]: data?.favicon,
	//TODO change to set value that gets from data
	[CHECKOUT_FORM_FIELDS.IS_ONE_COLUMN]: true,
});
